import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addPrivacy from "./components/addPrivacy";
export default {
  name: "privacy",
  mixins: [loadMoreList, serchSelect],
  components: {
    addPrivacy: addPrivacy
  },
  data: function data() {
    return {
      pagingReqFn: "privacyAgreementData",
      pagingReqValue: "",
      drawer: false,
      content: ''
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    consynopsistentView: function consynopsistentView(row) {
      this.content = this.$utils.textRepl(row.content);
      this.drawer = true;
    },
    del: function del(data) {
      var _this = this;

      var ids = data.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'privacyAgreementDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};